<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [leftButton]="{
    text: showTrackingSearch ? CONSTS.BACK_BUTTON : CONSTS.SEARCH_TRACKING,
    type: BUTTON_TYPES.TEXT_BUTTON,
  }"
  [rightButton]="{
    text: showTrackingSearch
      ? CONSTS.SEARCH_BUTTON
      : CONSTS.SELECT_CUSTOMER_BUTTON,
    type: BUTTON_TYPES.TEXT_BUTTON,
  }"
  [showErrorBanner]="hasError"
  [errorBannerType]="bannerType"
  (emitExit)="onExit()"
  (emitLeftClick)="onLeftClick()"
  (emitRightClick)="onRightClick()"
>
  <ion-row class="container">
    @if (showTrackingSearch) {
      <ion-col>
        <div>
          {{ CONSTS.SEARCH_TRACKING }}
          <app-header-search
            [displayUppercase]="true"
            (emitTextChange)="updateText($event)"
            (emitClearChange)="clear()"
          ></app-header-search>
        </div>
      </ion-col>
    } @else {
      <ion-col class="col">
        <ion-icon class="icon" [src]="IMAGES.DISABLED_CALENDAR"> </ion-icon>
        <div class="text">
          {{ data.date | date: "mediumDate" }}
        </div>
      </ion-col>
      <ion-col class="col">
        <ion-icon class="icon" [src]="IMAGES.LOCATION_DISABLED"> </ion-icon>
        <div class="text">
          {{ CONSTS.ROUTE.replace("%s", data.routeId) }}
        </div>
      </ion-col>
    }
  </ion-row>
</app-modal-frame>
